import { StatusType } from './types'

export const STATUS: Record<StatusType, string> = {
    400: 'Ops, você não \n deveria estar aqui.',
    404: 'A página não \n foi encontrada.',
    500: 'Algo deu errado, \n tente novamente.'
}
